import loadable from '@loadable/component';

export const productBoxTypes = {
	regular: loadable(() => import('./regular')),
	horizontal: loadable(() => import('./horizontal')),
}

export default productBoxTypes;